import axios from 'axios';
import {
  APP_SETTING_ADD_PROJECT_CONSTANT_BEGIN,
  APP_SETTING_ADD_PROJECT_CONSTANT_SUCCESS,
  APP_SETTING_ADD_PROJECT_CONSTANT_FAILURE,
  APP_SETTING_ADD_PROJECT_CONSTANT_DISMISS_ERROR,
} from './constants';
import { toast } from 'react-toastify';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function addProjectConstant(args = {}) {
  return (dispatch) => {
    dispatch({
      type: APP_SETTING_ADD_PROJECT_CONSTANT_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/constants`,
        args.data,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: APP_SETTING_ADD_PROJECT_CONSTANT_SUCCESS,
              data: res.data,
            });
            toast.success('Created Successfully !', {});
            resolve(res.data);
          } else {
            dispatch({
              type: APP_SETTING_ADD_PROJECT_CONSTANT_FAILURE,
              data: { error: 'Failed' },
            });
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: APP_SETTING_ADD_PROJECT_CONSTANT_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}
export function dismissAddProjectConstantError() {
  return {
    type: APP_SETTING_ADD_PROJECT_CONSTANT_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_ADD_PROJECT_CONSTANT_BEGIN:
      return {
        ...state,
        addProjectConstantPending: true,
        addProjectConstantError: null,
      };

    case APP_SETTING_ADD_PROJECT_CONSTANT_SUCCESS:
      return {
        ...state,
        addProjectConstantPending: false,
        addProjectConstantError: null,
        projectDetail: action.data,
      };

    case APP_SETTING_ADD_PROJECT_CONSTANT_FAILURE:
      return {
        ...state,
        addProjectConstantPending: false,
        addProjectConstantError: action.data.error,
      };

    case APP_SETTING_ADD_PROJECT_CONSTANT_DISMISS_ERROR:
      return {
        ...state,
        addProjectConstantError: null,
      };

    default:
      return state;
  }
}
